export default __webpack_public_path__ + "static/media/ic_target.ef745cfd.svg";